import styled from '@emotion/styled';
import { css } from '@emotion/react';

import useGroupProduct from '../../../../../hooks/useGroupProduct';

import {
  DealProduct,
  GroupKey,
  GroupMember,
  GroupMemberSubOption,
} from '../../../../../types';
import ListItem from '../../ListItem';
import CalendarDropdown from './CalendarDropdown';
import DealProductStepper from '../../../../../shared/DealProductStepper';

const dropdown = css`
  .title {
    line-height: 40px;
  }
`;

const stepper = css`
  .title {
    line-height: 30px;
  }
`;

const ValueWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
`;

export interface OptionItemProps {
  name: string;
  value: GroupMemberSubOption;
}

interface Props {
  productNo: number;
  groupKeys: GroupKey[];
  groupMembers: GroupMember[];
  dealProduct: DealProduct;
}

export default function CalendarContent({
  productNo,
  groupKeys,
  groupMembers,
  dealProduct,
}: Props) {
  const { optionList, changeOptionItem } = useGroupProduct({ productNo, groupKeys, groupMembers });

  const optionTitle = optionList.map((option) => option.title).join('·');

  return (
    <>
      <ListItem
        title={`${optionTitle} 선택`}
        css={dropdown}
      >
        <ValueWrapper>
          {optionList.map((option, index) => (
            <CalendarDropdown
              key={index}
              optionTitle={option.title}
              options={option.options}
              selectedOption={option.selectedOption}
              changeOptionItem={changeOptionItem}
            />
          ))}
        </ValueWrapper>
      </ListItem>
      <ListItem
        title="구매수량"
        css={stepper}
      >
        <DealProductStepper dealProduct={dealProduct} />
      </ListItem>
    </>
  );
}
